import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from "../../common/api.service"
import axios from 'axios'
import cookie from 'vue-cookies'

import { USER_LOGIN, USER_LOGOUT, USER_REGISTER, USER_UPDATE, USER_REQUEST_PASSWORD } from "./action.type"
import { SET_USER_LOGGEDIN, SET_USER_USERNAME, SET_USER_PREMIUM, SET_USER_OLDPREMIUM, SET_USER_EDUCATION, SET_USER_EDNEEDSUPDATE } from "./mutation.type"

Vue.use(Vuex)

export default {
  namespaced: false,
  state: {
    loggedIn: false,
    username: "",
    role: "student",
    hasPremium: false,
    oldPremium: false,
    updatedEd: true,
    year: 1,
    level: "vwo"
  },
  mutations: {
    [SET_USER_LOGGEDIN](state, data) {
      state.loggedIn = data
    },
    [SET_USER_USERNAME](state, data) {
      state.username = data
    },
    [SET_USER_PREMIUM](state, data) {
      state.hasPremium = data
    },
    [SET_USER_OLDPREMIUM](state, data) {
      state.oldPremium = data
    },
    [SET_USER_EDUCATION](state, data) {
      state.year = data.year
      state.level = data.level
    },
    [SET_USER_EDNEEDSUPDATE](state, data) {
      state.updatedEd = data
    }
  },
  actions: {
    async [USER_UPDATE](context) {
      let response = await ApiService.get("/user/me")
      if (response) {
        context.commit(SET_USER_LOGGEDIN, true)
        context.commit(SET_USER_OLDPREMIUM, response.data.oldPremium)
        context.commit(SET_USER_USERNAME, response.data.username)
        context.commit(SET_USER_EDUCATION, { year: response.data.year, level: response.data.level })
        context.commit(SET_USER_EDNEEDSUPDATE, response.data.updatedEd)
      }
    },
    async [USER_LOGIN](context, payload) {
      const response = await ApiService.post("auth/login", payload, true)
      if (response.status === 401) {
        return false
      }
      context.commit('setLoggedIn', true)
      context.commit('setUsername', payload.username)

      return true
    },
    async [USER_REGISTER](context, payload) {
      const response = await ApiService.post("user", payload, true)
      if (response.status == 400) {
        return response
      }
      context.commit('setLoggedIn', true)
      context.commit('setUsername', payload.username)

      return response
    },
    async [USER_REQUEST_PASSWORD](context, payload) {
      return await ApiService.post("user/requestpassword", { username: payload }, true)
    },
    async [USER_LOGOUT](context) {
      await ApiService.get("/user/logout")

      context.commit('setLoggedIn', false)
      context.commit('setUsername', "")

      axios.defaults.headers.common = {
        Authorization: ""
      }
    }
  }
}
